document.addEventListener('click', function (e) {
    const btn = e.target.closest('.custom-summary-closer');
    if (!btn) return;

    const targetDetails = btn.closest('details');
    const targetSummary = targetDetails?.querySelector('summary');
    if (targetDetails?.hasAttribute('open') && targetSummary) {
        targetSummary.click();
    }
});

document.addEventListener('click', function (e) {
  const dpLabel = e.target.closest('.custom-dropdown-label');
  if (!dpLabel) return;

  e.preventDefault();
  e.stopPropagation();

  const filterDropdown = dpLabel.closest('.custom-dropdown-wrap');
  if (!filterDropdown) return;

  const submenu = filterDropdown.querySelector('.custom-dropdown-content');
  if (!submenu) return;

  // --- CLOSE ALL FIRST ---
  document.querySelectorAll('.custom-dropdown-wrap.opened').forEach(d => {
    if (d !== filterDropdown) {
      d.classList.remove('opened');
      const sm = d.querySelector('.custom-dropdown-content');
      sm.style.height = sm.scrollHeight + 'px';
      sm.offsetHeight; // force reflow
      sm.style.height = '0px';
    }
  });

  // --- TOGGLE CURRENT ---
  const isOpen = filterDropdown.classList.contains('opened');

  if (isOpen) {
    // close this
    filterDropdown.classList.remove('opened');
    submenu.style.height = submenu.scrollHeight + 'px';
    submenu.offsetHeight;
    submenu.style.height = '0px';
  } else {
    // open this
    filterDropdown.classList.add('opened');

    submenu.style.height = 'auto';
    const height = submenu.scrollHeight + 'px';
    submenu.style.height = '0px';

    submenu.offsetHeight; // force reflow
    submenu.style.height = height;

    submenu.addEventListener(
      'transitionend',
      () => submenu.style.height = 'auto',
      { once: true }
    );
  }
});

// === ON LOAD: Open dropdowns already marked as "opened" ===
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-dropdown-wrap.opened').forEach(dropdown => {
    const submenu = dropdown.querySelector('.custom-dropdown-content');

    if (submenu){
      submenu.style.height = submenu.scrollHeight + 'px';

      submenu.addEventListener('transitionend', () => {
        submenu.style.height = 'auto';
      }, { once: true });

    } 
    
  });
});

window.openActiveDropdowns =  function openActiveDropdowns(){
    document.querySelectorAll('.custom-dropdown-wrap.opened').forEach(dropdown => {
    const submenu = dropdown.querySelector('.custom-dropdown-content');
    if (submenu) {
      submenu.style.height = submenu.scrollHeight + 'px';
        submenu.addEventListener('transitionend', () => {
        submenu.style.height = 'auto';
      }, { once: true });
    }
  });
}

const observerDropdown = new MutationObserver((mutations) => {
  // only react if actual child elements changed
  const shouldRun = mutations.some(m => m.type === 'childList');
  if (shouldRun) openActiveDropdowns();
});

document.querySelectorAll('.custom-dropdown-wrap').forEach(el => {
  observerDropdown.observe(el, { childList: true, subtree: true, attributes: false });
});